import { RootState } from '../../../';
import { selectIsEdEnabled } from './../provider/selectors.ts';

export const selectIcd10CodeUploadEnabled = (state: RootState) =>
  (state.app.settings.AmbulatoryICD10CodeUploadEnabled && !selectIsEdEnabled(state)) ||
  (state.app.settings.EdICD10CodeUploadEnabled && selectIsEdEnabled(state));
